import { useCalendarViewQuery, type UseCalendarViewQueryArgs } from "@tellescope/tanstack-query";
import { useMemo } from "react";
import { buildCalendarMdbFilter, type CalendarFilters } from "../filters";

export interface UseCalendarEventsWithFiltersArgs<Count extends boolean = false>
  extends Omit<UseCalendarViewQueryArgs<Count>, "mdbFilter"> {
  filters?: CalendarFilters;
  currentUserId?: string;
}

/**
 * Wraps useCalendarViewQuery to accept strongly-typed CalendarFilters and translate
 * them into an mdbFilter before invoking the query.
 */
export const useCalendarEventsWithFilters = <Count extends boolean = false>({
  filters,
  currentUserId,
  ...rest
}: UseCalendarEventsWithFiltersArgs<Count>) => {
  const mdbFilter = useMemo(() => buildCalendarMdbFilter(filters, currentUserId), [filters, currentUserId]);

  return useCalendarViewQuery({ ...rest, mdbFilter });
};
